export default class Label {
    constructor(box21_api) {
        this.api = box21_api;
    }

    async all() {
        let formData = new FormData();
        return this.api.post_with_token('/available-models', formData);
    }
}